import { AsyncButton } from '@/shared/components/button/async-button';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

export const Route = createFileRoute('/playground')({
  component: RouteComponent,
});

function RouteComponent() {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div>
      <AsyncButton
        onClick={() => {
          setIsLoading(!isLoading);
          //   setTimeout(() => {
          //     setIsLoading(false);
          //   }, 600);
        }}
        isLoading={isLoading}
      >
        Click me
      </AsyncButton>
    </div>
  );
}
